import { Api, BuildVersion, ENCRYPT_STORAGE } from "../../config/config";
import { dto_selected_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { GET_CART_PIDs } from "../../functions/funtion";
import { dto_Customer } from "../../classes/dto-customer";
import { dto_common } from "../../classes/dto-common";
import { postMethod } from "../post";

export const api_LoadPromotionCategorySection = (SCHEDULEDORDER = false) => {
  var url = `${Api}/?ControllerName104=/ApiML`;

  return postMethod(
    url,
    '{"SERVICENAME":"LoadSectionListToCustomerApp","SCHEDULEDORDER":' +
      SCHEDULEDORDER +
      ',"CSID":' +
      dto_Customer.CSID +
      ',"ZONEID":' +
      dto_common.DeliveryZoneID +
      ',"MERCHANTZONEID":' +
      dto_common.ZoneId +
      ',"MTYPE":"' +
      dto_common.MTYPE +
      '","DINETYPE":' +
      dto_common.DineType +
      ',"VERSION":"' +
      BuildVersion +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '"}',
  );
};

export const api_LoadRecomendedProductsForSelectedItem = async (PID) => {
  let PIDs = await GET_CART_PIDs();
  var url = `${Api}/?ControllerName104=/ApiML`;
  return postMethod(
    url,
    '{"SERVICENAME":"GetRecomendedItemsForSelectedItem","CSID":' +
      dto_Customer.CSID +
      ',"ZONEID":' +
      dto_common.ZoneId +
      ',"MTYPE":"' +
      dto_common.MTYPE +
      '","MID":' +
      dto_selected_merchant_or_product.MID +
      ',"PID":' +
      PID +
      ',"GUNO":"' +
      PIDs +
      '","CSP":"' +
      dto_common.CSP +
      '","COUNTRYCODE":"' +
      dto_common.NatvieCountry +
      '","COORDINATES":"' +
      dto_common.CurrentCordinate +
      '","NIC":"' +
      dto_Customer.NIC +
      '"}',
  );
};

export const api_DaitonnAnalytical = async () => {
  if (dto_StartupPageLoadInfo.isTrackAnalytics === true) {
    let AnalyticalData = ENCRYPT_STORAGE.getItem("AnalyticalData");
    if (AnalyticalData !== null && AnalyticalData !== undefined) {
      var url = `${Api}/?ControllerName104=/ApiML`;
      postMethod(
        url,
        '{"SERVICENAME":"DaitonnAnalytical","STRANALYTICAL":' +
          JSON.stringify(JSON.stringify(AnalyticalData)) +
          ',"VERSION":"' +
          BuildVersion +
          '","CSP":"' +
          dto_common.CSP +
          '","COUNTRYCODE":"' +
          dto_common.NatvieCountry +
          '","COORDINATES":"' +
          dto_common.CurrentCordinate +
          '","NIC":"' +
          dto_Customer.NIC +
          '","CSID":"' +
          dto_Customer.CSID +
          '"}',
      );
      ENCRYPT_STORAGE.removeItem("AnalyticalData");
    }
    //this.SaveNIC();
  }
};

export const Api_DrawAnalyticalPath = async (TYPE, GUID) => {
  // TYPE 42 MID
  // TYPE 1 PID
  // TYPE 7 CATID
  // TYPE 45 MACID
  // console.log(dto_StartupPageLoadInfo.isTrackAnalytics);
  if (dto_StartupPageLoadInfo.isTrackAnalytics === true) {
    var currentdate = new Date();
    var datetime =
      "" +
      currentdate.getDate() +
      "/" +
      (currentdate.getMonth() + 1) +
      "/" +
      currentdate.getFullYear() +
      "  " +
      currentdate.getHours() +
      ":" +
      currentdate.getMinutes() +
      ":" +
      currentdate.getSeconds();
    let AnalyticalData = ENCRYPT_STORAGE.getItem("AnalyticalData");
    let UID = 0;
    let IsCustomer = false;
    if (dto_Customer.CSID !== 0) {
      UID = dto_Customer.CSID;
      IsCustomer = true;
    } else {
      UID = dto_Customer.NIC;
      IsCustomer = false;
    }
    if (AnalyticalData === undefined || AnalyticalData === null) {
      ENCRYPT_STORAGE.removeItem("AnalyticalData");
      ENCRYPT_STORAGE.setItem(
        "AnalyticalData",
        JSON.stringify([
          {
            UID: UID,
            TYPE: TYPE,
            GUID: GUID,
            DATEANDTIME: datetime,
            ISCUSTOMER: IsCustomer,
            PUBlICIP: "",
          },
        ]),
      );
    } else {
      var GetResponce = AnalyticalData;
      var SetlistResponce = [];
      SetlistResponce = GetResponce;
      var setValue = {
        UID: UID,
        TYPE: TYPE,
        GUID: GUID,
        DATEANDTIME: datetime,
        ISCUSTOMER: IsCustomer,
        PUBlICIP: "",
      };
      SetlistResponce.push(setValue);
      ENCRYPT_STORAGE.setItem(
        "AnalyticalData",
        JSON.stringify(SetlistResponce),
      );
    }
  } else {
    ENCRYPT_STORAGE.removeItem("AnalyticalData");
  }
};
